export default __webpack_public_path__ + "assets/img/lemon_logo_dark.344eb4a0821ce87c15abd692496b5f80.png";